/*!
 * Owned by Pankaj Maurya LLC. Copyright (c) 2026 Pankaj Maurya LLC.
 * It is copyrighted could not be used or reused without written permission from Pankaj Maurya LLC.
 * Contact: pankaj@pankajmaurya.com
 * Support: https://designflowdigitals.com
 */

(function() {
  var SECTION_ID = 'cart-drawer';
  var isUpdating = false;

  function routes() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openDrawer() {
    var d = getDrawer();
    if (d) {
      d.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDrawer() {
    var d = getDrawer();
    if (d) {
      d.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  window.CartDrawer = { open: openDrawer, close: closeDrawer };

  /* Close drawer events */
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-overlay]')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Loading state ── */
  function showLoading() {
    var panel = document.querySelector('[data-cart-drawer-panel]');
    if (!panel) return;
    if (panel.querySelector('.cd__loader')) return;
    var loader = document.createElement('div');
    loader.className = 'cd__loader';
    loader.innerHTML = '<div class="cd__spinner"></div>';
    panel.appendChild(loader);
  }

  function hideLoading() {
    document.querySelectorAll('.cd__loader').forEach(function(l) { l.remove(); });
  }

  /* ── Refresh drawer via Section Rendering API ── */
  function refreshDrawer() {
    showLoading();

    return fetch(routes() + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data[SECTION_ID];
        if (!html) {
          hideLoading();
          return;
        }

        var temp = document.createElement('div');
        temp.innerHTML = html;

        var drawer = getDrawer();
        var newDrawer = temp.querySelector('[data-cart-drawer]');

        if (newDrawer && drawer) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
        }

        hideLoading();
        updateCartCounts();
      })
      .catch(function(err) {
        console.error('Cart drawer refresh failed:', err);
        hideLoading();
      });
  }

  document.addEventListener('cart:refresh', function() {
    refreshDrawer().then(function() { openDrawer(); });
  });

  window.CartDrawer.refresh = refreshDrawer;

  function updateCartCounts() {
    fetch(routes() + 'cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.hv2-cart-count, [data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.querySelectorAll('a[href*="/cart"] sup').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function() {});
  }

  /* ── AJAX Cart helpers ── */
  function cartChange(key, quantity) {
    if (isUpdating) return Promise.resolve();
    isUpdating = true;

    return fetch(routes() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return refreshDrawer(); })
    .then(function() { isUpdating = false; })
    .catch(function(err) {
      console.error('Cart change failed:', err);
      isUpdating = false;
      hideLoading();
    });
  }

  function cartAdd(formData) {
    if (isUpdating) return Promise.resolve();
    isUpdating = true;

    return fetch(routes() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function() { return refreshDrawer(); })
    .then(function() {
      isUpdating = false;
      openDrawer();
    })
    .catch(function(err) {
      console.error('Add to cart failed:', err);
      isUpdating = false;
      hideLoading();
    });
  }

  /* ── Quantity +/- and Remove (event delegation) ── */
  document.addEventListener('click', function(e) {
    if (isUpdating) return;

    var minus = e.target.closest('[data-qty-minus]');
    if (minus) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cartChange(minus.getAttribute('data-key'), Math.max(0, parseInt(minus.getAttribute('data-qty'), 10) - 1));
      return;
    }

    var plus = e.target.closest('[data-qty-plus]');
    if (plus) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cartChange(plus.getAttribute('data-key'), parseInt(plus.getAttribute('data-qty'), 10) + 1);
      return;
    }

    var remove = e.target.closest('[data-remove-item]');
    if (remove) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cartChange(remove.getAttribute('data-key'), 0);
      return;
    }
  }, true);

  /* ──────────────────────────────────────────────────────
     ADD TO CART: intercept the BUTTON CLICK, not form submit.
     The editor blocks form submit events but NOT button clicks.
     We prevent the click from ever triggering a form submission.
     ────────────────────────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
    if (!btn) return;
    if (isUpdating) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var originalText = btn.getAttribute('data-original-text') || btn.textContent.trim();
    btn.setAttribute('data-original-text', originalText);
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var formData = new FormData(form);
    if (!formData.get('selling_plan')) {
      var scope = form.closest('.pp-section') || form.closest('[data-section-id]') || document;
      var planInput = scope.querySelector('input[name="selling_plan"]:checked') || scope.querySelector('select[name="selling_plan"]') || scope.querySelector('input[name="selling_plan"]');
      var sellingPlanId = planInput && planInput.value ? String(planInput.value) : '';
      if (sellingPlanId) {
        formData.append('selling_plan', sellingPlanId);
      }
    }

    cartAdd(formData)
      .then(function() {
        btn.disabled = false;
        btn.textContent = originalText || 'ADD TO CART';
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = originalText || 'ADD TO CART';
      });
  }, true);

  /* Also block the form submit as a safety net */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* Store original button text on load */
  document.querySelectorAll('form[action*="/cart/add"] [type="submit"]').forEach(function(btn) {
    btn.setAttribute('data-original-text', btn.textContent.trim());
  });

  /* ── Cart icon click → open drawer ── */
  document.addEventListener('click', function(e) {
    var cartBtn = e.target.closest('.hv2-cart');
    if (cartBtn && !cartBtn.closest('[data-cart-drawer]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
      return;
    }

    var cartLink = e.target.closest('a[href*="/cart"]:not([href*="/checkout"]):not([href*="/cart/"])');
    if (cartLink && !cartLink.closest('[data-cart-drawer]') && !cartLink.closest('.cp-section')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
      return;
    }
  }, true);
})();
